class ParallaxSection extends HTMLElement {
  connectedCallback() {
    this.images = this.querySelectorAll('.wt-parallax__img');
    this.rotation = Number(this.dataset.rotation) || 5;

    if (!this.images.length) return;

    this.onScroll = () => {
      const sectionRect = this.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      // animate only while section is visible
      if (sectionRect.bottom < 0 || sectionRect.top > windowHeight) return;

      // progress through section (0 → 1)
      const progress =
        (windowHeight - sectionRect.top) /
        (sectionRect.height + windowHeight);

      this.images.forEach((img, index) => {
        const depth = (index + 1) * 70;
        const translateY = (progress - 0.5) * depth;
        const rotate = (progress - 0.5) * this.rotation;

        img.style.transform = `
          translate3d(0, ${translateY}px, 0)
          rotate(${rotate}deg)
        `;
      });
    };

    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.onScroll();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
  }
}

customElements.define('parallax-section', ParallaxSection);
